export * from "@vaadin/board/vaadin-board-row.js";
/**
 * @license
 * Copyright (c) 2000 - 2024 Vaadin Ltd.
 *
 * This program is available under Vaadin Commercial License and Service Terms.
 *
 *
 * See https://vaadin.com/commercial-license-and-service-terms for the full
 * license.
 */
import { BoardRow as _BoardRow } from './generated/BoardRow.js';

export * from './generated/BoardRow.js';

/**
 * @deprecated BoardRow is deprecated and will be removed in Vaadin 26.
 * Consider using Dashboard or DashboardLayout as an alternative.
 */
export const BoardRow = _BoardRow;
